import React, { useState } from 'react';
import { Card, Typography, Select } from 'antd';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';

const { Text } = Typography;
const { Option } = Select;

export default function HeatMap({
  heatMapData = [],
  dailyHeatMapData = [],
  monthlyHeatMapData = [],
}) {
  const [mode, setMode] = useState('hour'); // 'hour' | 'daily' | 'monthly'

  const getData = () => {
    if (mode === 'hour') {
      return [...heatMapData].sort((a, b) => {
        const getMinutes = (time) => {
          const [hours, minutes] = time.split(':').map(Number);
          return hours * 60 + minutes;
        };
        return getMinutes(a.hour) - getMinutes(b.hour);
      });
    } else if (mode === 'daily') {
      return [...dailyHeatMapData].sort((a, b) =>
        a.date.localeCompare(b.date)
      );
    } else if (mode === 'monthly') {
      return [...monthlyHeatMapData].sort((a, b) =>
        a.month.localeCompare(b.month)
      );
    }
    return [];
  };

  const displayKey = mode === 'hour' ? 'hour' : mode === 'daily' ? 'date' : 'month';

  return (
    <Card size='small' className='heatmap-card'>
      <div className='chart-header' style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div className='chart-title'>
          <span className='ticket-count'>Heat Map</span>
          <br />
          <Text type='secondary' style={{ fontSize: '12px' }}>
            Peak load hours/days/months
          </Text>
        </div>
        <Select size='small' value={mode} onChange={setMode} style={{ width: 100,borderRadius:"10px" ,}} className="heat-dropdown">
          <Option value='hour'>Today</Option>
          <Option value='daily'>This Month</Option>
          <Option value='monthly'>This Year</Option>
        </Select>
      </div>
      <ResponsiveContainer width='100%' height={337}>
        <BarChart data={getData()} barCategoryGap='10%' margin={{ top: 5, right: 5, bottom: 10 }}>
          <XAxis
            dataKey={displayKey}
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 10 }}
            interval={0}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 10 }}
            allowDecimals={false}
          />
          <Tooltip />
          <Bar dataKey='count' fill='#1890FF' barSize={15} />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
}
